import React from "react";
import Container from "./Container";
import {
  Bitcoin,
  BNB,
  Ethereum,
  LebronJamesNoBackground,
  PortfolioMovement,
  WashingtonWizards,
  DallasMavericks,
  LAClippers,
  LALakers,
  MilwaukeeBucks,
  BostonCelticsP,
  NYKnicks,
  EllipseBottom,
  EllipseTop,
} from "../assets/img";
import PriceChart from "./PriceChart";
import DoughnutChart from "./DoughnutChart";

const teams = [
  { team: "Washington Wizards", percentage: 38.9, image: WashingtonWizards },
  { team: "Dallas Mavericks", percentage: 2.5, image: DallasMavericks },
  { team: "New York Knicks", percentage: 24.5, image: NYKnicks },
  { team: "Milwaukee Bucks", percentage: 18.9, image: MilwaukeeBucks },
  { team: "Los Angeles Lakers", percentage: 8.4, image: LALakers },
  { team: "Los Angeles Clippers", percentage: 3.9, image: LAClippers },
  { team: "Dallas Mavericks", percentage: 2.5, image: DallasMavericks },
  { team: "Boston Celtics", percentage: 6.5, image: BostonCelticsP },
];

const lakersPlayers = [
  {
    name: "LeBron James",
    value: 500.0,
    change: "+7.77%",
    date: "Today",
  },
  {
    name: "Anthony Davis",
    value: 400.0,
    change: "+8.77%",
    date: "2 days ago",
  },
  {
    name: "D’Angelo Russell",
    value: 500.0,
    change: "+7.77%",
    date: "3 days ago",
  },
  {
    name: "Jarred Vanderbilt",
    value: 500.0,
    change: "+7.77%",
    date: "Today",
  },
  {
    name: "Austin Reaves",
    value: 500.0,
    change: "+7.77%",
    date: "2 days ago",
  },
];

const AccountPage = () => {
  return (
    <div className="min-h-screen bg-white py-8">
      <Container className="grid grid-cols-12  gap-6">
        {/* Portfolio */}
        <div className="col-span-12 lg:col-span-8 1xl:col-span-9 order-2 lg:order-1 space-y-6">
          <h2 className="hidden lg:block text-2xl font-semibold text-black">
            My Portfolio
          </h2>
          {/* My Portfolio */}
          <div className="hidden lg:grid grid-cols-3 gap-4">
            {/* BTC */}
            <div className="col-span-1 bg-white p-4 rounded-3xl shadow-custom2">
              <div className="flex items-center gap-1 1xl:gap-3">
                <span className="w-9 h-9 1xl:w-12 1xl:h-12 bg-[#EF8E19] rounded-2xl flex items-center justify-center text-white font-bold shadow-custom1">
                  <Bitcoin className="w-4 h-4 1xl:w-6 1xl:h-6" />
                </span>
                <div>
                  <p className="text-sm 1xl:text-lg font-semibold text-black">
                    BTC<span className="text-[#919EAB]">/USDT</span>
                  </p>
                  <p className="text-[10px] 1xl:text-[13px] text-[#919EAB]">
                    Bitcoin
                  </p>
                </div>
                <div className="ml-auto text-right">
                  <p className="font-semibold text-black text-xs 1xl:text-lg">
                    $135,25
                  </p>
                  <p className="text-[#FF4842] text-[10px] 1xl:text-xs">
                    ▼ $32 (2%)
                  </p>
                </div>
              </div>
            </div>

            {/* ETH */}
            <div className="col-span-1 bg-white p-4 rounded-3xl shadow-custom2">
              <div className="flex items-center gap-1 1xl:gap-3">
                <span className="w-9 h-9 1xl:w-12 1xl:h-12 bg-[#636890] rounded-2xl flex items-center justify-center text-white font-bold shadow-custom1">
                  <Ethereum className="w-4 h-4 1xl:w-6 1xl:h-6" />
                </span>
                <div>
                  <p className="text-sm 1xl:text-lg font-semibold text-black">
                    ETH<span className="text-[#919EAB]">/USDT</span>
                  </p>
                  <p className="text-[10px] 1xl:text-[13px] text-[#919EAB]">
                    Ethereum
                  </p>
                </div>
                <div className="ml-auto text-right">
                  <p className="font-semibold text-black text-xs 1xl:text-lg">
                    $215,00
                  </p>
                  <p className="text-[#6DD64D] text-[10px] 1xl:text-xs">
                    ▲ $23 (2%)
                  </p>
                </div>
              </div>
            </div>

            {/* BNB */}
            <div className="col-span-1 bg-white p-4 rounded-3xl shadow-custom2">
              <div className="flex items-center gap-1 1xl:gap-3">
                <span className="w-9 h-9 1xl:w-12 1xl:h-12 bg-[#F0B90B] rounded-2xl flex items-center justify-center text-white font-bold shadow-custom1">
                  <BNB className="w-4 h-4 1xl:w-6 1xl:h-6" />
                </span>
                <div>
                  <p className="text-sm 1xl:text-lg font-semibold text-black">
                    BNB<span className="text-[#919EAB]">/USDT</span>
                  </p>
                  <p className="text-[10px] 1xl:text-[13px] text-[#919EAB]">
                    Binance
                  </p>
                </div>
                <div className="ml-auto text-right">
                  <p className="font-semibold text-black text-xs 1xl:text-lg">
                    $135,25
                  </p>
                  <p className="text-red-500 text text-[10px] 1xl:text-xs">
                    ▼ $32 (2%)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Price Movement */}
          <div className="hidden lg:block bg-white p-4 rounded-3xl shadow-custom2 h-80">
            <p className="flex items-center justify-start gap-4 text-lg text-black font-semibold">
              <PortfolioMovement /> Price Movement
            </p>
            <div className="h-full">
              <PriceChart
                gradientStart="rgba(59, 130, 246, 0.3)"
                gradientEnd="rgba(59, 130, 246, 0)"
                lineColor="#3b82f6"
              />
            </div>
          </div>

          {/* Portfolio Breakdown */}
          <div className="bg-white p-6 rounded-3xl shadow-custom2">
            <p className="font-semibold text-2xl mb-4">Portfolio Breakdown</p>
            <div className="flex flex-col md:flex-row items-center justify-between item gap-6">
              {/* Donut Chart */}
              <div className="flex-1 w-60 h-60">
                <DoughnutChart
                  labels={["Stocks", "Crypto", "Bonds"]}
                  // data={[20, 25, 25, 15, 5, 3, 7]}
                  data={[6, 2, 4, 5, 25, 15, 27]}
                  colors={[
                    "#DD9E68", // orange (top small)
                    "#73CDCF", // teal (tiny slice top-right)
                    "#977EE6", // purple (right-top small)
                    "#E09DAF", // pink (right)
                    "#1F4DFF", // blue (bottom-right big slice)
                    "#D1687F", // dark pink (bottom-left)
                    "#D4D1D8", // gray (top-left big slice)
                  ]}
                  centerLabel="Total % Change"
                  centerValue="38.9%"
                />
              </div>

              {/* Breakdown List */}
              <div className="flex-1 grid grid-cols-1 w-full gap-y-4">
                {teams?.map(({ team, percentage, image }, i) => (
                  <div
                    className="flex items-center justify-between text-xs font-semibold font-inter"
                    key={i}
                  >
                    <div className="flex items-center justify-start gap-4">
                      <img
                        src={image}
                        alt="Team logo"
                        className="w-[22px] h-[22px]"
                      />
                      <p className="uppercase ">{team}</p>
                    </div>
                    <p>{percentage}%</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-span-12 lg:col-span-4 1xl:col-span-3 order-1 lg:order-2">
          <div className="bg-white rounded-3xl shadow-custom2 overflow-hidden">
            <div className="bg-[#1F4DFF] p-6 text-white text-center">
              <p className="text-2xl font-semibold mb-3">Johnsmith3857</p>
              <p className="text-sm font-semibold">John Smith</p>
            </div>
            <div className="p-6 space-y-6">
              {/* Total Balance */}
              <p className="text-2xl mb-4 text-black font-semibold">
                Total Balance
              </p>
              <div className="flex items-center justify-center">
                <div className="relative bg-secondary w-full lg:w-[274px] h-[155px] rounded-3xl flex flex-col items-center gap-6 justify-center self-center lg:self-auto">
                  <EllipseTop className="absolute right-0 top-0" />
                  <p className="text-2xl font-bold text-white font-inter">
                    $1,445,000
                  </p>
                  <p className="bg-[#1F4DFF] text-white px-2 py-1 rounded-[26px] text-xs font-inter">
                    ▲ $32 (2%)
                  </p>
                  <EllipseBottom className="absolute left-0 bottom-0" />
                </div>
              </div>

              {/* Portfolio Balance */}
              <div>
                <p className="font-semibold text-2xl  mb-2">
                  Portfolio Balance
                </p>
                <div className="space-y-2 text-sm">
                  {lakersPlayers?.map((player, index) => {
                    return (
                      <div
                        className="flex items-center justify-between"
                        key={index}
                      >
                        <div className="flex items-center justify-start gap-2">
                          <img
                            src={LebronJamesNoBackground}
                            alt="lebron"
                            className="w-12 h-12 object-cover rounded-full"
                          />{" "}
                          <div className="flex flex-col items-start ">
                            <p className="text-sm font-semibold text-black">
                              {player?.name}
                            </p>
                            <p className="text-xs text-[#919EAB]">
                              {player?.date}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start flex-col font-inter">
                          <p className="text-sm font-semibold">
                            ${player?.value}
                          </p>
                          <p className="text-green-400 text-sm font-semibold">
                            {player?.change}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Buttons */}
              <div className="flex gap-3">
                <button className="flex-1 bg-[#0E983D] text-white py-[10px] text-sm font-semibold rounded-xl">
                  Buy
                </button>
                <button className="flex-1 bg-black text-white py-[10px] text-sm font-semibold rounded-xl">
                  Sell
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AccountPage;
